"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectOnError = void 0;
const ERROR_ENDOPOINTS = Object.freeze({
  GODADDY: 'godaddy-503',
  AFTERNIC: '_error',
  REG_123: '404'
});
const inferRedirectUrl = () => {
  const {
    origin
  } = window.location;
  const originLower = origin.toLowerCase();
  let redirectUrl = `https://www.godaddy.com/${ERROR_ENDOPOINTS.GODADDY}`;
  if (originLower.includes('afternic')) {
    redirectUrl = `${origin}/${ERROR_ENDOPOINTS.AFTERNIC}`;
  } else if (originLower.includes('123-reg')) {
    redirectUrl = `${origin}/${ERROR_ENDOPOINTS.REG_123}`;
  } else if (originLower.includes('godaddy')) {
    redirectUrl = `${origin}/${ERROR_ENDOPOINTS.GODADDY}`;
  }
  return redirectUrl;
};
const redirectOnError = (error, errorRedirectUrl) => {
  if (!errorRedirectUrl) {
    errorRedirectUrl = inferRedirectUrl();
  }
  if (error) {
    window.location.href = errorRedirectUrl;
  }
};
exports.redirectOnError = redirectOnError;